// Module
var code = "<template> <require from=\"app/cm/components/case/task-intervention-icon\"></require> <require from=\"app/cm/components/case/case-service-grid\"></require> <case-service-grid case-id.bind=\"caseId\" show-actions=\"true\"></case-service-grid> </template> ";
// Exports
module.exports = code;